const toLowerCase = (str) => str?.toLowerCase()

export default toLowerCase;
